import { Component, ViewChild, Output, EventEmitter, ElementRef } from '@angular/core';
import { Router } from '@angular/router';

import { AbstractComponent } from 'src/core/common/component/AbstractComponent';

import { GSSideService } from './GSSideService';
import { environment } from '../../../environments/environment';
@Component({
  selector: 'gs-sidebar',
  templateUrl: './GSSidebar.html',
  styleUrls: ['./GSSidebar.scss'],
})
export class GSSidebarComponent extends AbstractComponent {
  @ViewChild('mainSidebar', { static: false }) mainSidebar;
  @Output() mainSidebarHeight: EventEmitter<any> = new EventEmitter<any>();

  public scope = {
    show: false,
    menuItems: {},
  };
  /** */
  constructor(private service: GSSideService, private router: Router) {
    super();
  }

  public componentWillMount() {
    this.scope.show = true;
    this.service.get().subscribe((res: any) => {
      this.scope.menuItems = res;
      if(location.hostname.indexOf(environment.local_ip) > -1) {
        this.service.getDev().subscribe((dev:any) => {
          this.scope.menuItems['DeveloperTools'] = [];
          this.scope.menuItems['DeveloperTools'].push({
            category: "AdminMenu",
            icon: "fa fa-bug",
            name: "Developer Tool",
            path: '/devtool',
          });
        })  
      }
    });
  }

  public componentWillUnmount() {
    this.mainSidebarHeight.emit(this.mainSidebar.nativeElement.offsetHeight);
  }

  public isMenu(key) {
    return Object.keys(this.scope.menuItems).indexOf(key) > -1;
  }

  public styleClass(path) {
    let classes = '';
    return this.router.url.indexOf(path) > -1 ? `active ${classes}` : `${classes}`;
  }

  
  public isActive(path: string) {
    return this.router.url.indexOf(path) > -1;
  }

  public routerLink(path) {
    this.router.navigate([path]);
  }
}
